export const customWidths = {
	pageWidth: '1200px',
};
